import React from 'react'
import { FormControlLabel, Switch, FormHelperText, FormControl, SwitchProps } from '@mui/material'
import { useField } from 'formik'

export type FormSwitchFieldProps = Omit<SwitchProps, 'name' | 'checked' | 'onChange'> & {
  name: string
  label: string
}

const FormSwitchField: React.FC<FormSwitchFieldProps> = ({ name, label, ...props }) => {
  const [field, meta, helpers] = useField({ name, type: 'checkbox' })
  const errorText = meta.touched && meta.error ? meta.error : ''

  return (
    <FormControl error={!!errorText} component="fieldset" variant="standard" margin="dense">
      <FormControlLabel
        control={
          <Switch
            {...field}
            {...props}
            checked={!!field.value}
            onChange={(e) => helpers.setValue(e.target.checked)}
            color="success"
          />
        }
        label={label}
        sx={{
          '& .MuiFormControlLabel-label': {
            fontSize: '0.9rem',
            userSelect: 'none'
          }
        }}
      />
      {!!errorText && <FormHelperText sx={{ mt: 0 }}>{errorText}</FormHelperText>}
    </FormControl>
  )
}

export default FormSwitchField
